import React, { useState } from 'react';
import { useHasPermissions } from '../accessControl/hooks/useHasPermissions';
import { Show } from '../shared/Show';
import { TextButtonTW } from '../../tailwindComponents/buttonTW/TextButtonTW';
import { ILenderCompanyData } from '../../types/lenders/ILenderCompany';
import { DeactivateLenderCompanyModal } from './DeactivateLenderCompanyModal';
import { useUpdateLenderMutation } from '../../API/lenders/LenderCompanyApi';
import { checkForMutationSuccess } from '../../API/checkForMutationSuccess';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';

interface ISwitchLenderCompanyActivateButtonProps {
  lenderCompany: ILenderCompanyData;
}

export const SwitchLenderCompanyActivateButton: React.FC<ISwitchLenderCompanyActivateButtonProps> = ({
  lenderCompany,
}) => {
  const hasDeactivatePermissions = useHasPermissions([ePermissions.LenderCompanyEdit]);
  const [deactivateLender, setDeactivateLender] = useState<boolean>(false);

  const [updateLenderCompany, { isLoading }] = useUpdateLenderMutation();

  const handleUpdate = async () => {
    const result = await updateLenderCompany({ id: lenderCompany.id, body: { isActive: true } });
    checkForMutationSuccess(result, 'Activate Lender Company', 'Error Activating Lender Company');
  };

  return (
    <Show when={hasDeactivatePermissions}>
      {` | `}
      <Show
        when={lenderCompany.isActive}
        fallback={
          <TextButtonTW className={'font-normal !text-black'} disabled={isLoading} onClick={handleUpdate}>
            Activate
          </TextButtonTW>
        }
      >
        <TextButtonTW className={'font-normal !text-black'} onClick={() => setDeactivateLender(true)}>
          Deactivate
        </TextButtonTW>
      </Show>
      <DeactivateLenderCompanyModal
        open={deactivateLender}
        setOpen={setDeactivateLender}
        lenderCompany={lenderCompany}
      />
    </Show>
  );
};
